export enum SettingsActionTypes {
    START_REQUEST = 'SETTINGS_START_REQUEST',
    END_REQUEST = 'SETTINGS_END_REQUEST',
    GET_SETTINGS_SUCCESS = 'GET_SETTINGS_SUCCESS',
    GET_SETTINGS_ERROR = 'GET_SETTINGS_ERROR',
    GET_TIMESLOTS_SUCCESS = 'GET_TIMESLOTS_SUCCESS',
    GET_TIMESLOTS_ERROR = 'GET_TIMESLOTS_ERROR',
    GET_LOADING_IMAGE = 'GET_LOADING_IMAGE'
}
